import { User } from 'domain/user'
import { Button } from 'primereact/button'
import { Dialog } from 'primereact/dialog'

export interface ConfirmDeleteUserProps {
  visible: boolean
  hideDialog: () => void
  user: User
  deleteUserItem: () => void
}
const ConfirmDeleteUser = (props: ConfirmDeleteUserProps) => {
  const deleteUserDialogFooter = (
    <div className='users-dialog-footer'>
      <Button
        label='Não'
        icon='pi pi-times'
        outlined
        className='users-btn-cancel'
        onClick={props.hideDialog}
      />
      <Button
        label='Sim'
        icon='pi pi-check'
        severity='danger'
        className='users-btn-confirm'
        onClick={props.deleteUserItem}
      />
    </div>
  )
  return (
    <Dialog
      visible={props.visible}
      style={{ width: '450px' }}
      header='Confirmar Exclusão'
      modal
      className='users-confirm-dialog'
      footer={deleteUserDialogFooter}
      onHide={props.hideDialog}
    >
      <div className='users-confirm-content'>
        <i className='pi pi-exclamation-triangle users-warning-icon' />
        <div className='users-confirm-text'>
          {props.user && (
            <>
              <p>Tem certeza que deseja excluir o usuário</p>
              <strong className='users-highlight'>{props.user.name}</strong>?
              <p className='users-warning-text'>
                Esta ação não pode ser desfeita.
              </p>
            </>
          )}
        </div>
      </div>
    </Dialog>
  )
}

export default ConfirmDeleteUser
